import React from 'react';
import {Container, Row} from 'react-grid-system';
import IosLogo from './ios/IosLogo';
import SectionDescription from './general/SectionDescription';
import QRCode from "./general/QRCode";
import {LinkProvider} from "../../../../res/LinkProvider";
import {getMobileOperatingSystem, OS} from "../../../../utils/CheckPlatform";

interface States {

}

interface Props {
}

class IosSection extends React.Component<Props, States> {

    state: States

    constructor(props: Props) {
        super(props)
        this.state = {}

    }

    getDescription = () => {
        let description = "iPhone with iOS version 13 or major."

        if (getMobileOperatingSystem() === OS.unknow) {
            description += " To download app scan QRCode on right."
        }

        return description
    }

    render() {
        return (
            <section
                className="iosSection">
                <Container>
                    <Row>
                        <IosLogo/>
                        <SectionDescription
                            title="iOS"
                            description={this.getDescription()}
                        />
                        <QRCode
                            text={LinkProvider.latestIosApp}/>
                    </Row>
                </Container>
            </section>
        )
    }
}

export default IosSection;
